module.exports = __webpack_public_path__ + "img/zephyr.b5c5def3.png";